import { UseVenueMapStateReturnValue } from '@vividseats/venue-maps-component'

import { JSONMap } from '@/components/shared/map/components/simple-map'
import type { ComposedListing, DefaultProviderProps, DefaultStateType, ListingsGroup } from '@/types/app-types'

interface MapSelectors {
    mapContent?: JSONMap
    mapState: MapState
    lowestPricedListingInSection: ComposedListing | ListingsGroup | undefined
    venueMapState: UseVenueMapStateReturnValue // @vividseats/venue-maps-component
    isMapboxMapEnabled: boolean
    mapInitialized: boolean
}

export type MapStateType = DefaultStateType<JSONMap>

export interface MapState {
    minPrice: MinPrice
    pos: Pos
    hoveredSectionId: string
    isMouseDown: boolean
    isDragging: boolean
    isDoubleClicked: boolean
}

export interface MapDispatch {
    setHoveredSectionId: (payload: string) => void
    setIsMouseDown: (isDown: boolean) => void
    setIsDragging: (isDragging: boolean) => void
    setIsDoubleClicked: (isDoubleClicked: boolean) => void
}
export interface MapContextType {
    state: MapStateType
    selectors: MapSelectors
    dispatch: MapDispatch
}

type MapParams = { mapId?: string }

export interface MapProviderProps extends DefaultProviderProps<MapStateType, MapParams> {
    initialEnabled?: boolean
}

export enum ActionType {
    SET_MIN_PRICE,
    SET_POS,
    SET_HOVERED_SECTION_ID,
    SET_MOUSE_DOWN,
    SET_DRAGGING,
    SET_DOUBLE_CLICK,
}

export interface MinPrice {
    id: string
    value: number
}

export interface MinPriceAction {
    type: ActionType.SET_MIN_PRICE
    payload: MinPrice
}

export interface Pos {
    x: number
    y: number
}

export interface PosAction {
    type: ActionType.SET_POS
    payload: Pos
}

export interface HoveredSectionAction {
    type: ActionType.SET_HOVERED_SECTION_ID
    payload: string
}

export interface MouseAction {
    type: ActionType.SET_DRAGGING | ActionType.SET_DOUBLE_CLICK | ActionType.SET_MOUSE_DOWN
    payload: boolean
}
